import * as Yup from 'yup';

export class EntityValidation {
    static create = Yup.object().shape({
        entityDescription: Yup.string().required("Entity Description Is Required."),
        entityName: Yup.string().required("Entity Name Is Required."),
     })
}